/**
 * Web-only display helper for the playtest UI. Rules live in shared/playtest.
 */
import { RESULT_MESSAGES } from '../../../shared/playtest';

const PLACEHOLDER_CARD = { name: 'Unknown card', typeLine: null, imageSmall: null };

/** Snapshot display data for a card; unknown ids (rows without a card) get a placeholder name. */
export const displayOf = (session, cardId) => session.cardViews.get(cardId) ?? PLACEHOLDER_CARD;

/** Shown when an action runs before the deck session is ready. */
const NOT_READY_TEXT = 'The session is not ready yet.';

/** Text for a refused action: `result` is a SessionResult, or null when no session is ready. */
export const refusalText = (result) => (result === null ? NOT_READY_TEXT : RESULT_MESSAGES[result]);
